import { IntegrationEventItem } from '@zond/api-interfaces';

export const getLatestEventPerEntity = (events: IntegrationEventItem[]): IntegrationEventItem[] => {
  const entityMap = new Map<string, IntegrationEventItem>();
  events.forEach((event) => {
    const entityId = event.url;
    const existing = entityMap.get(entityId);
    if (!existing || new Date(event.createdAt) > new Date(existing.createdAt)) {
      entityMap.set(entityId, event);
    }
  });
  return Array.from(entityMap.values()).sort(
    (a, b) => new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime()
  );
};

export const shouldUseCollapsibleView = (events: IntegrationEventItem[]): boolean => {
  const uniqueEntities = getLatestEventPerEntity(events);
  return uniqueEntities.length > 10;
};
